import Vue from 'vue'
import Router from 'vue-router'
import ProchainPassages from '../components/ProchainPassages.vue'
import DetailBus from '../components/DetailCarte'
import VueMatomo from 'vue-matomo'
import Arrets from "../components/Arrets.vue";
import Lignes from "../components/Lignes.vue";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path:'/arrets/:routeId',
      name:'Arrets',
      component: Arrets
    },
    {
      path:'/',
      name:'Lignes',
      component: Lignes
    },
    {
      path: '/prochainPassages/:stopIds*',
      name: 'ProchainPassages',
      component: ProchainPassages,
      meta: {
        persistQuery: true
      }
    },
    {
      path: '/carte/:tripId/:stopId/:numSequence',
      name: 'detailBus',
      component: DetailBus,
      meta: {
        watchParam: 'stopId'
      }
    }
  ]
})

Vue.use(VueMatomo, {
  host: 'https://pretapartir.matomo.cloud/',
  siteId: 16,
  trackerFileName: 'matomo',
  enableLinkTracking: true,
  trackInitialView: true,
  router: router,
  debug: false,
})

router.afterEach((to, from) => {
  window._paq.push(['setCustomUrl', 'https://evad.nuamouv.com/tempsreel/#' + to.fullPath])
  window._paq.push(['trackPageView'])
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js